import type { ReactNode } from 'react';

import type { SoapContent } from '@/entities/session-note';

import { SessionNoteSection } from './soap-session-note-content/session-note-section';

interface Props {
    content: SoapContent;
    updateSection: (key: keyof SoapContent, value: string) => void;
    disclaimer?: ReactNode;
}

export function SoapSessionNoteContent({ content, updateSection, disclaimer }: Props) {
    return (
        <div className="space-y-8">
            <div className="flex flex-col gap-10">
                <SessionNoteSection
                    title="Subjective"
                    content={content.subjective}
                    onContentChange={(value) => updateSection('subjective', value)}
                />
                <SessionNoteSection
                    title="Objective"
                    content={content.objective}
                    onContentChange={(value) => updateSection('objective', value)}
                />
                <SessionNoteSection
                    title="Assessment"
                    content={content.assessment}
                    onContentChange={(value) => updateSection('assessment', value)}
                />
                <SessionNoteSection
                    title="Plan"
                    content={content.plan}
                    onContentChange={(value) => updateSection('plan', value)}
                />
            </div>
            {disclaimer}
        </div>
    );
}
